import * as client_hooks from '../../../src/hooks.client.ts';


export { matchers } from './matchers.js';

export const nodes = [
	() => import('./nodes/0'),
	() => import('./nodes/1'),
	() => import('./nodes/2'),
	() => import('./nodes/3'),
	() => import('./nodes/4'),
	() => import('./nodes/5'),
	() => import('./nodes/6'),
	() => import('./nodes/7'),
	() => import('./nodes/8'),
	() => import('./nodes/9'),
	() => import('./nodes/10'),
	() => import('./nodes/11'),
	() => import('./nodes/12'),
	() => import('./nodes/13'),
	() => import('./nodes/14'),
	() => import('./nodes/15'),
	() => import('./nodes/16'),
	() => import('./nodes/17'),
	() => import('./nodes/18'),
	() => import('./nodes/19'),
	() => import('./nodes/20'),
	() => import('./nodes/21'),
	() => import('./nodes/22'),
	() => import('./nodes/23'),
	() => import('./nodes/24'),
	() => import('./nodes/25')
];

export const server_loads = [5,6,2];

export const dictionary = {
		"/": [~9],
		"/auth": [12,[4]],
		"/blog": [~13],
		"/blog/[slug]": [~14],
		"/field": [15],
		"/policies/[policySlug]": [~16,[5]],
		"/profile": [~17,[6]],
		"/profile/[...catchAll]": [~18,[6]],
		"/stats": [~21,[8]],
		"/stats/all": [22,[8]],
		"/stats/analytics": [23,[8]],
		"/stats/charts/[qNum]": [24,[8]],
		"/stats/demo-filters": [25,[8]],
		"/s/[questionId]": [19],
		"/s/[questionId]/result": [20,[7]],
		"/[page]": [~10,[2]],
		"/[page]/[slug]": [~11,[3]]
	};

export const hooks = {
	handleError: client_hooks.handleError || (({ error }) => { console.error(error) }),
	init: client_hooks.init,
	reroute: (() => {}),
	transport: {}
};

export const decoders = Object.fromEntries(Object.entries(hooks.transport).map(([k, v]) => [k, v.decode]));

export const hash = false;

export const decode = (type, value) => decoders[type](value);

export { default as root } from '../root.js';